import { BatchMessagesQueryParams } from 'src/shared/models';
import { get } from '../../shared/services/http.service';

export const getBatchMessages = async (applicationId: number, params: BatchMessagesQueryParams) => {
  return get(`/applications/${applicationId}/outbound-messages`, { params });
};
